"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var immutable_1 = require("immutable");

var ForecastCoordinatorTreeDataDTO_1 = require("../model/ForecastCoordinatorTreeDataDTO");

var ForecastCoordinatorTreeDataDTOConverter_1 = require("./ForecastCoordinatorTreeDataDTOConverter");
/**
 * @author OPt
 */


var ForecastCoordinatorTreeDataDTOConverterImpl =
/*#__PURE__*/
function (_ForecastCoordinatorT) {
  _inherits(ForecastCoordinatorTreeDataDTOConverterImpl, _ForecastCoordinatorT);

  function ForecastCoordinatorTreeDataDTOConverterImpl() {
    _classCallCheck(this, ForecastCoordinatorTreeDataDTOConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(ForecastCoordinatorTreeDataDTOConverterImpl).apply(this, arguments));
  }

  _createClass(ForecastCoordinatorTreeDataDTOConverterImpl, [{
    key: "toObject",

    /**
     * @inheritDoc
     */
    value: function toObject(source, conversions) {
      return new ForecastCoordinatorTreeDataDTO_1.ForecastCoordinatorTreeDataDTO(ForecastCoordinatorTreeDataDTO_1.ForecastCoordinatorTreeDataDTO.schema.entityName.valueOfField(source), ForecastCoordinatorTreeDataDTO_1.ForecastCoordinatorTreeDataDTO.schema.windowId.valueOf(conversions.toClassReferenceId(source.windowId)), ForecastCoordinatorTreeDataDTO_1.ForecastCoordinatorTreeDataDTO.schema.windowItemId.valueOf(source.windowItemId ? conversions.toClassReferenceId(source.windowItemId) : null), ForecastCoordinatorTreeDataDTO_1.ForecastCoordinatorTreeDataDTO.schema.storeSpecification.valueOfField(source), ForecastCoordinatorTreeDataDTO_1.ForecastCoordinatorTreeDataDTO.schema.promotionName.valueOfField(source), ForecastCoordinatorTreeDataDTO_1.ForecastCoordinatorTreeDataDTO.schema.promotionCode.valueOfField(source), ForecastCoordinatorTreeDataDTO_1.ForecastCoordinatorTreeDataDTO.schema.promotionId.valueOf(source.promotionId ? conversions.toClassReferenceId(source.promotionId) : null), ForecastCoordinatorTreeDataDTO_1.ForecastCoordinatorTreeDataDTO.schema.windowName.valueOfField(source), ForecastCoordinatorTreeDataDTO_1.ForecastCoordinatorTreeDataDTO.schema.windowTypeId.valueOf(source.windowTypeId ? conversions.toClassReferenceId(source.windowTypeId) : null), ForecastCoordinatorTreeDataDTO_1.ForecastCoordinatorTreeDataDTO.schema.approveActionType.valueOfField(source), ForecastCoordinatorTreeDataDTO_1.ForecastCoordinatorTreeDataDTO.schema.dateFrom.valueOf(source.dateFrom ? conversions.toDate(source.dateFrom) : null), ForecastCoordinatorTreeDataDTO_1.ForecastCoordinatorTreeDataDTO.schema.dateTo.valueOf(source.dateTo ? conversions.toDate(source.dateTo) : null), ForecastCoordinatorTreeDataDTO_1.ForecastCoordinatorTreeDataDTO.schema.productId.valueOf(source.productId ? conversions.toClassReferenceId(source.productId) : null), ForecastCoordinatorTreeDataDTO_1.ForecastCoordinatorTreeDataDTO.schema.productExternalId.valueOfField(source), ForecastCoordinatorTreeDataDTO_1.ForecastCoordinatorTreeDataDTO.schema.productName.valueOfField(source), ForecastCoordinatorTreeDataDTO_1.ForecastCoordinatorTreeDataDTO.schema.systemVolume.valueOf(conversions.toBigNumber(source.systemVolume)), ForecastCoordinatorTreeDataDTO_1.ForecastCoordinatorTreeDataDTO.schema.promoVolume.valueOf(conversions.toBigNumber(source.promoVolume)), ForecastCoordinatorTreeDataDTO_1.ForecastCoordinatorTreeDataDTO.schema.lastPromoVolumeUpdate.valueOf(source.lastPromoVolumeUpdate ? conversions.toDate(source.lastPromoVolumeUpdate) : null), ForecastCoordinatorTreeDataDTO_1.ForecastCoordinatorTreeDataDTO.schema.salesSystemVolume.valueOf(conversions.toBigNumber(source.salesSystemVolume)), ForecastCoordinatorTreeDataDTO_1.ForecastCoordinatorTreeDataDTO.schema.salesPromoVolume.valueOf(conversions.toBigNumber(source.salesPromoVolume)), ForecastCoordinatorTreeDataDTO_1.ForecastCoordinatorTreeDataDTO.schema.volumeDifferencePiece.valueOf(source.volumeDifferencePiece ? conversions.toBigNumber(source.volumeDifferencePiece) : null), ForecastCoordinatorTreeDataDTO_1.ForecastCoordinatorTreeDataDTO.schema.volumeDifferencePercentage.valueOf(source.volumeDifferencePercentage ? conversions.toBigNumber(source.volumeDifferencePercentage) : null), ForecastCoordinatorTreeDataDTO_1.ForecastCoordinatorTreeDataDTO.schema.approvalLimitPiece.valueOf(conversions.toBigNumber(source.approvalLimitPiece)), ForecastCoordinatorTreeDataDTO_1.ForecastCoordinatorTreeDataDTO.schema.approvalLimitPercentage.valueOf(conversions.toBigNumber(source.approvalLimitPercentage)), ForecastCoordinatorTreeDataDTO_1.ForecastCoordinatorTreeDataDTO.schema.promoPrice.valueOf(source.promoPrice ? conversions.toBigNumber(source.promoPrice) : null), ForecastCoordinatorTreeDataDTO_1.ForecastCoordinatorTreeDataDTO.schema.regularPrice.valueOf(source.regularPrice ? conversions.toBigNumber(source.regularPrice) : null), ForecastCoordinatorTreeDataDTO_1.ForecastCoordinatorTreeDataDTO.schema.secondaryPlacement.valueOfField(source), ForecastCoordinatorTreeDataDTO_1.ForecastCoordinatorTreeDataDTO.schema.numberOfSites.valueOfField(source), //
      ForecastCoordinatorTreeDataDTO_1.ForecastCoordinatorTreeDataDTO.schema.cmForecast.valueOf(source.cmForecast ? conversions.toBigNumber(source.cmForecast) : null), ForecastCoordinatorTreeDataDTO_1.ForecastCoordinatorTreeDataDTO.schema.onPicture.valueOfField(source));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      return {
        entityName: source.entityName,
        windowId: conversions.toDocumentReferenceId(source.windowId),
        windowItemId: conversions.toDocumentReferenceId(source.windowItemId),
        storeSpecification: source.storeSpecification,
        promotionName: source.promotionName,
        promotionCode: source.promotionCode,
        promotionId: conversions.toDocumentReferenceId(source.promotionId),
        windowName: source.windowName,
        windowTypeId: conversions.toDocumentReferenceId(source.windowTypeId),
        approveActionType: source.approveActionType,
        dateFrom: source.dateFrom ? conversions.fromDate(source.dateFrom) : null,
        dateTo: source.dateTo ? conversions.fromDate(source.dateTo) : null,
        productId: conversions.toDocumentReferenceId(source.productId),
        productExternalId: source.productExternalId,
        productName: source.productName,
        systemVolume: conversions.fromBigNumber(source.systemVolume),
        promoVolume: conversions.fromBigNumber(source.promoVolume),
        lastPromoVolumeUpdate: source.lastPromoVolumeUpdate ? conversions.fromDate(source.lastPromoVolumeUpdate) : null,
        salesSystemVolume: conversions.fromBigNumber(source.salesSystemVolume),
        salesPromoVolume: conversions.fromBigNumber(source.salesPromoVolume),
        volumeDifferencePiece: source.volumeDifferencePiece ? conversions.fromBigNumber(source.volumeDifferencePiece) : null,
        volumeDifferencePercentage: source.volumeDifferencePercentage ? conversions.fromBigNumber(source.volumeDifferencePercentage) : null,
        approvalLimitPiece: conversions.fromBigNumber(source.approvalLimitPiece),
        approvalLimitPercentage: conversions.fromBigNumber(source.approvalLimitPercentage),
        promoPrice: source.promoPrice ? conversions.fromBigNumber(source.promoPrice) : null,
        regularPrice: source.regularPrice ? conversions.fromBigNumber(source.regularPrice) : null,
        secondaryPlacement: source.secondaryPlacement,
        numberOfSites: source.numberOfSites,
        //
        cmForecast: source.cmForecast ? conversions.fromBigNumber(source.cmForecast) : null,
        onPicture: source.onPicture
      };
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "objectToArray",
    value: function objectToArray(instance, conversions) {
      var document = this.toDocument(instance, conversions);
      return immutable_1.List(ForecastCoordinatorTreeDataDTOConverterImpl.keys.map(function (k) {
        return document[k];
      }));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "arrayToObject",
    value: function arrayToObject(source, conversions) {
      var data = {};
      ForecastCoordinatorTreeDataDTOConverterImpl.keys.forEach(function (key, index) {
        if (typeof source[index] !== 'undefined') {
          data[key] = source[index];
        }
      });
      return this.toObject(data, conversions);
    }
  }]);

  return ForecastCoordinatorTreeDataDTOConverterImpl;
}(ForecastCoordinatorTreeDataDTOConverter_1.ForecastCoordinatorTreeDataDTOConverter);

exports.ForecastCoordinatorTreeDataDTOConverterImpl = ForecastCoordinatorTreeDataDTOConverterImpl;
ForecastCoordinatorTreeDataDTOConverterImpl.keys = Object.getOwnPropertyNames(ForecastCoordinatorTreeDataDTO_1.ForecastCoordinatorTreeDataDTO.schema);